
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edo_45I23nuWWXITG_452yWFUF2yd9GXnwa5S4D8frpfB14C8sMeta } from "/var/www/2025-06-26_17_44/pages/edo.vue?macro=true";
import { default as helpwex4p0e55N6ZqGdgw5ALU9ZxWzCxYfTI_mX0UhuMikMMeta } from "/var/www/2025-06-26_17_44/pages/help.vue?macro=true";
import { default as cargoDCYP4NJoAPorwfDJVqzEDDI0LGSojOMrAIIwr6dILtUMeta } from "/var/www/2025-06-26_17_44/pages/cargo.vue?macro=true";
import { default as index0u4PrNFSNO3DD5KVKHp6QqH2fbl7E8rIpCep4n_45h6cgMeta } from "/var/www/2025-06-26_17_44/pages/index.vue?macro=true";
import { default as _91slug_93c4O_45q9VnwOxqk8tK9v_upFVcGDIW1kT12SjqEkRBl5EMeta } from "/var/www/2025-06-26_17_44/pages/[slug].vue?macro=true";
import { default as cookieYAjtRfQ6z_ZnkvNrUw634LVlODVN1avHqdKgcHmHLCMMeta } from "/var/www/2025-06-26_17_44/pages/cookie.vue?macro=true";
import { default as belarusQTDLgCP7oIACV_45BirvrnCGaRY2_b5g7t_45zjqQN9ONMQMeta } from "/var/www/2025-06-26_17_44/pages/belarus.vue?macro=true";
import { default as bonusesvirjUf8_q3RTExNCk22_45marQN0_W38jdKPHxanYoP_YMeta } from "/var/www/2025-06-26_17_44/pages/bonuses.vue?macro=true";
import { default as apiNia62RfRw2kAesZD_450gPrmk0rHqCLHBUYPUF8ssG_45YgMeta } from "/var/www/2025-06-26_17_44/pages/dev/api.vue?macro=true";
import { default as cmstE5eNJvc41itQyGBelUv5WVqmWmg9VjRIjbSVsdTVhQMeta } from "/var/www/2025-06-26_17_44/pages/dev/cms.vue?macro=true";
import { default as konkurs5Z_45jnlcr823pAZoCXK6cp0I8vENHBsg2IV9xlARTfg0Meta } from "/var/www/2025-06-26_17_44/pages/konkurs.vue?macro=true";
import { default as successDjSVXRA8XDDRcZCzQrqgURpklgo7mYFdlmEieaQZci4Meta } from "/var/www/2025-06-26_17_44/pages/success.vue?macro=true";
import { default as tariffsQ8lB2VqlDLAhTav12BLM_45NMrnvfwU0yFZ9PFKgaY4L8Meta } from "/var/www/2025-06-26_17_44/pages/tariffs.vue?macro=true";
import { default as vacancy5_1H_h9O_KUmdG_tMTcBFbrB_O8YMHpaXpUoTtEwifwMeta } from "/var/www/2025-06-26_17_44/pages/vacancy.vue?macro=true";
import { default as contacts8_45HGs5MLZIOKjqGQtfhOLd5MF_WKNVtEC8q_45r7D93L0Meta } from "/var/www/2025-06-26_17_44/pages/contacts.vue?macro=true";
import { default as giveawayciKdQa0sjzyLwLf9mFw5huqH8lcFJRm0ywmbG_cJ0r4Meta } from "/var/www/2025-06-26_17_44/pages/giveaway.vue?macro=true";
import { default as guide_45lkNwpZPqDXsp5UGaXg2nZ7WkvcOVu2T_45S4HojeRXXJJdYMeta } from "/var/www/2025-06-26_17_44/pages/guide-lk.vue?macro=true";
import { default as servicesBYvnxTcV8y_ww_45DYJKDRwgSECDcpLb7XW6nwR_45wD_7YMeta } from "/var/www/2025-06-26_17_44/pages/services.vue?macro=true";
import { default as telegramE4l5zR7eMTNU1HXrT7D7pti3PGo5ITTEnvTfLI3xlOkMeta } from "/var/www/2025-06-26_17_44/pages/telegram.vue?macro=true";
import { default as documentsEuKhyVs_nWsuQgprWAKaYpXtc56cosuMeNCtABZ8onIMeta } from "/var/www/2025-06-26_17_44/pages/documents.vue?macro=true";
import { default as franchise9lbOfxlv1s55Y5aaBqtR2LG89HnabBbV4GSo4tZJJ_45YMeta } from "/var/www/2025-06-26_17_44/pages/franchise.vue?macro=true";
import { default as insurance9AMQqFranMNxH27f25b5y_45xehUs6ivKIw2xp6_QHNqAMeta } from "/var/www/2025-06-26_17_44/pages/insurance.vue?macro=true";
import { default as kirghiziaRMRaN94FuGhCtofuPJSB9GvdcE_dDLsnIcQQ1oBkYWkMeta } from "/var/www/2025-06-26_17_44/pages/kirghizia.vue?macro=true";
import { default as mapSchemeOX76Eh6A3L3XbeWzr1uPmNvVBW_45eZrn1tiy3TyrmoPQMeta } from "/var/www/2025-06-26_17_44/pages/mapScheme.vue?macro=true";
import { default as _91id_938GUSwTiVyYbjocVWw9z9thGD9RuWgwdJ34Zo_xn4bXUMeta } from "/var/www/2025-06-26_17_44/pages/news/[id].vue?macro=true";
import { default as return_45sdNhPONQmEpLpJjyFDIOZbHRVw0y_im4GADpu4mSbBXC8Meta } from "/var/www/2025-06-26_17_44/pages/return-sd.vue?macro=true";
import { default as smsClientNpKWojkdPvtCV7d9COJFFio444h_VZmK5tCmZryrWN4Meta } from "/var/www/2025-06-26_17_44/pages/smsClient.vue?macro=true";
import { default as terminalsTwo6mN1b4jLHY_o88V70AWVMp_NakmKFVPRVbPEKnTUMeta } from "/var/www/2025-06-26_17_44/pages/terminals.vue?macro=true";
import { default as iframefH_O8w9r_tN4aTFXakk_cUTG_45hx0mZBao8yqlTPeGGwMeta } from "/var/www/2025-06-26_17_44/pages/dev/iframe.vue?macro=true";
import { default as directionsVO1arGfx6ukUrr5J1sYegnNlx2uxMNNkfyiFW4NXyRAMeta } from "/var/www/2025-06-26_17_44/pages/directions.vue?macro=true";
import { default as kazakhstanAjUVgFHsJT9OrlnewEUeT4I6HiFQFa_SPxeJaPYHCo0Meta } from "/var/www/2025-06-26_17_44/pages/kazakhstan.vue?macro=true";
import { default as indexigydudXffnhodtkIygNnsFeV8a2oX0Me1_a_QHYmANcMeta } from "/var/www/2025-06-26_17_44/pages/news/index.vue?macro=true";
import { default as svgspVzzJXzxMzZ_45yzaMV9kX2HEwjMMY6tq240vNyG2XaQMeta } from "/var/www/2025-06-26_17_44/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failp9a7d24GZjIHSpKFQ2B2ltU1YjW_1opJHlVSRNMiBNwMeta } from "/var/www/2025-06-26_17_44/pages/vzpay-fail.vue?macro=true";
import { default as constructorMRHWgJmimPeMLnKCwNhilflYCf9dt7kaPwAnqVE9jtcMeta } from "/var/www/2025-06-26_17_44/pages/constructor.vue?macro=true";
import { default as indexSBU6i56mlyV87zxsbhX9tqPewbVQevD4oHWWlKRJUe8Meta } from "/var/www/2025-06-26_17_44/pages/gifts/index.vue?macro=true";
import { default as informationmxHrGhNTIthD6XEEvWK_45lJrLBtPhRPjzrJ48FTViH8YMeta } from "/var/www/2025-06-26_17_44/pages/information.vue?macro=true";
import { default as lightADxdpwBgm6x820q8gyszTxnJMwVZED3VVh8y053RpbIMeta } from "/var/www/2025-06-26_17_44/pages/order/light.vue?macro=true";
import { default as claim_45filingp1YCwsIpyNRo4r3vo2xwcLubL7_JGjJzwfT14URtdToMeta } from "/var/www/2025-06-26_17_44/pages/claim-filing.vue?macro=true";
import { default as _91type_93bn9aXC4ak5wp1UyTfSsdJtpmJn7eEjtvNTCy33l6vIgMeta } from "/var/www/2025-06-26_17_44/pages/gifts/[type].vue?macro=true";
import { default as marketplaces2fqnc3imIItEFdmVWNOE9RJosUDwK7otlNlptuIDxKkMeta } from "/var/www/2025-06-26_17_44/pages/marketplaces.vue?macro=true";
import { default as networkshopsIC7rcwZVMLmu5XaO3rrmDWZdUFwF05X3EhSPSohtBToMeta } from "/var/www/2025-06-26_17_44/pages/networkshops.vue?macro=true";
import { default as online_45storeXOTNS_45nyEbQPE88Z3tnyNzs4KCzBFNWHQFuOdkdmBHYMeta } from "/var/www/2025-06-26_17_44/pages/online-store.vue?macro=true";
import { default as managebmnmG9fhAiiY1GfnVsPIwc1GxI2ge59ZKCyu_yX3tMUMeta } from "/var/www/2025-06-26_17_44/pages/order/manage.vue?macro=true";
import { default as registrationAmhVArAlNgarfk2GRP4dy_J5JxoUkks0ZZbvQC224ucMeta } from "/var/www/2025-06-26_17_44/pages/registration.vue?macro=true";
import { default as run_45scheduleXTl5ZJcFP7mCy7GkMq7ExtsZdcDK0UjV_45ZUzWckkuskMeta } from "/var/www/2025-06-26_17_44/pages/run-schedule.vue?macro=true";
import { default as safe_45custody5QipI88xEOT5ix0T2d1V2JSNx_uPBKbMHiOgrQGwJiYMeta } from "/var/www/2025-06-26_17_44/pages/safe-custody.vue?macro=true";
import { default as imageLYUcylIWkiDnn7xC8ra_451Te0vQ05GBg4v_BvdG8FhQUMeta } from "/var/www/2025-06-26_17_44/pages/ui-kit/image.vue?macro=true";
import { default as indexeqTnKXquCjuyd66N9tHkUqu8YqAvUXN_45BjiV6dc0qQkMeta } from "/var/www/2025-06-26_17_44/pages/ui-kit/index.vue?macro=true";
import { default as bagnWfnxWofL40vaDopRcpmKMMfURUae4frBdtexCEHcBYMeta } from "/var/www/2025-06-26_17_44/pages/wrapping/bag.vue?macro=true";
import { default as boxc2l8PAabIDX7PfgqrqjeDWrMnRx5yoBmAL_6m2_452vCAMeta } from "/var/www/2025-06-26_17_44/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingZ4n0eVkEHrsHuqFIfRWchfrRw65J5xd_45JxVyw1MJb9cMeta } from "/var/www/2025-06-26_17_44/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayO6LhDDvKLhK4ldp3wxBR3aN4WU5PfRWIhhosFBNMTM4Meta } from "/var/www/2025-06-26_17_44/pages/happybirthday.vue?macro=true";
import { default as manageHpSpi_eSx8GWw7ShUhI2E4fqZ7KcKAIUY8eCyoqr7noMeta } from "/var/www/2025-06-26_17_44/pages/iframe/manage.vue?macro=true";
import { default as authp9wZ7YehA4VqCgkXAxh_bam3zsdw16XuUIugrLDH_45n8Meta } from "/var/www/2025-06-26_17_44/pages/personal/auth.vue?macro=true";
import { default as public_45Mqtzd5IHPt99exDSC4xpuoa0ZPSULFNGrFqBf_SnF4Meta } from "/var/www/2025-06-26_17_44/pages/ui-kit/public.vue?macro=true";
import { default as already_45answery1BZ3GapQkfX_45QQaBJcCEg0Dw36lCXAzYUFcm8lzVK8Meta } from "/var/www/2025-06-26_17_44/pages/already-answer.vue?macro=true";
import { default as tariffsGOlGWpPJ7qmtbvIUyzwVJQT5irdJpwqxOVFvkoHl3OQMeta } from "/var/www/2025-06-26_17_44/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93G9mu9ZPWbG_0txAYEvI6APR8_45ConwZDNEW_454d4siyWIMeta } from "/var/www/2025-06-26_17_44/pages/order/pay/[id].vue?macro=true";
import { default as indexd272QiqXq3zeDxcXThjOEgnBySYLebvgASqbuWMZgKEMeta } from "/var/www/2025-06-26_17_44/pages/personal/index.vue?macro=true";
import { default as privacy_45policyd9hPvzupRU_8inVOyBMgpd8dZ4Idfn9XxNhFf77yOZcMeta } from "/var/www/2025-06-26_17_44/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93vtV2ob5GgfGmO4zdam5gEd35sQHZQCBkeFIgz7XNa28Meta } from "/var/www/2025-06-26_17_44/pages/welcome/[hash].vue?macro=true";
import { default as indexhA8FnfEh6BnIgxqdHnKrrGRB7wRbEq57q3uAJ_45QjkiwMeta } from "/var/www/2025-06-26_17_44/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiaTbebB_nrrpSkvMG5wgoZLxAutAzz2L55GVgh6Ixk44UMeta } from "/var/www/2025-06-26_17_44/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsjsP4rnYFWG4PDbicJgwn6pmnYm0pK4znMUQyACPw0bcMeta } from "/var/www/2025-06-26_17_44/pages/payment-methods.vue?macro=true";
import { default as qr_45info_455YUmT84ewL1w4fP4rMUNQJ5wSak_456Xp9H4D7ug32LcMeta } from "/var/www/2025-06-26_17_44/pages/payment/qr-info.vue?macro=true";
import { default as successBruIxxxpW0JDXwz63Cr5fsCXqwzQZEY6d4yarKtdGQMMeta } from "/var/www/2025-06-26_17_44/pages/payment/success.vue?macro=true";
import { default as importC2IKMgAgGvLQIxCfZwrujT2f3Xob_45FpDFTQIJsmFTqoMeta } from "/var/www/2025-06-26_17_44/pages/personal/import.vue?macro=true";
import { default as logoutj9V_wzVrZ_zRvbh0IyGsmcLAoHWZzySqbwQ_jPJ6yuYMeta } from "/var/www/2025-06-26_17_44/pages/personal/logout.vue?macro=true";
import { default as address_45deliveryivxTUKn9lNsx7ecs0LLsxwJsFaZfyAS83mkNBteFU7cMeta } from "/var/www/2025-06-26_17_44/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryNp_YnNSyvOP_Na_45LCG7wLoW_451_cu8MA6oZffujOCc94Meta } from "/var/www/2025-06-26_17_44/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024Re1C2fBIbZRqdoHDyK1FLGdSWt9JDK9fKL9tdDHvM5gMeta } from "/var/www/2025-06-26_17_44/pages/happynewyear2024.vue?macro=true";
import { default as ozonV8YhVbEzp8ufmjtUpwgrlwxNaHxk0W4HFcAevjOFohwMeta } from "/var/www/2025-06-26_17_44/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failc5yyxo5bNCxBfppcVljwXk7BQrgEzNXaA0pCx3W8r18Meta } from "/var/www/2025-06-26_17_44/pages/payment/pay-fail.vue?macro=true";
import { default as accountsYdmlLc_3xeatDjvTGSJjZY4kN4vdkiUZvLMELpKMUgMeta } from "/var/www/2025-06-26_17_44/pages/personal/account.vue?macro=true";
import { default as prohibited_45goods61PMHAqn88U8hJ3fl8_45iYjrLTZhcyUQp446_45wRZL09kMeta } from "/var/www/2025-06-26_17_44/pages/prohibited-goods.vue?macro=true";
import { default as directionNpJ3lsSu0PFQgKhPBtthobO1Fb153WQJvOadWOJWNLkMeta } from "/var/www/2025-06-26_17_44/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupBx_SW3nhgYVJn9UjhUFbqyrb1kskeSiiaj0pl3ZNKT0Meta } from "/var/www/2025-06-26_17_44/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargonkPKQt7R8E17tJYM_ytKlQBQFI0MhfrNoobQO4YnqBcMeta } from "/var/www/2025-06-26_17_44/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorltYqSPQEpy7pOyDDA_45lGHQPuJvQk_45QwPK5W4Fp6ij5gMeta } from "/var/www/2025-06-26_17_44/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesd7VZKKLMeffL_45rMlmLohSP0HrAHq3F2PNNn824AgdSUMeta } from "/var/www/2025-06-26_17_44/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93_Af5OTJajQzQIHIjJdtwkTUYHZqtabBvcZqUdJV_4552QMeta } from "/var/www/2025-06-26_17_44/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoQI66U0QFQ56Z3AQtmA1yyqnIYoptnKKQLSAtzZOXw44Meta } from "/var/www/2025-06-26_17_44/pages/payment/card-info.vue?macro=true";
import { default as discountLye18ptGRYL4mzHsxB4Oq_45YnM7UIY277Or_cPU6StS0Meta } from "/var/www/2025-06-26_17_44/pages/personal/discount.vue?macro=true";
import { default as hard_45boxXzjnjmuc5_45nRc6yXOVy7lXqtIBywvlgq0Hqs0bpePYQMeta } from "/var/www/2025-06-26_17_44/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptg6U3QoeMBZbAZnC5PK4oPZTI3grrF6Zo2lEvo6lJqQwMeta } from "/var/www/2025-06-26_17_44/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917kVPXIyMhp0xOBlzeS9YwGfVLQQsWiyjdTY37kAXucPMMeta } from "/var/www/2025-06-26_17_44/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45application0_45YumkL7dY2LiuXmwKPbqqb63BnOxDMTtJK90moKcnIMeta } from "/var/www/2025-06-26_17_44/pages/mobile-application.vue?macro=true";
import { default as indextL8MsYhcrwl9CuWInQN8V1OgWyoMeEn7GJ71Jd5g3yYMeta } from "/var/www/2025-06-26_17_44/pages/order/create/index.vue?macro=true";
import { default as boatNQ4ZrcT_mjuBVshKJylptXbUnVDuYpGU9ZwkSM_9agcMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/boat.vue?macro=true";
import { default as sofa4YANHjWDl_2qA7_45y7EXZY7uNK4mq2stowD938gNcaU4Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboardWJD589HvWAhS06A_45zKwTp0z9WmFGbuFdHDLxrB1KGSIMeta } from "/var/www/2025-06-26_17_44/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesoyEfvErExsgYndiP_45nTH2Mu1_ctf5pr_s6Dix6Vz5YwMeta } from "/var/www/2025-06-26_17_44/pages/personal/promocodes.vue?macro=true";
import { default as benchhf_syB1gdjz97FjLRENw8DgzQx6P95r2tpig8JSTyT4Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/bench.vue?macro=true";
import { default as bookswKSUwcpjmQdBdRFe_18nClJEZ5ZUtti0ka2pOBhWx_sMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/books.vue?macro=true";
import { default as cablegNgrAtWtWOtv2YS7nSZFLzuaSMs45_ucoB8eWK4V1O0Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/cable.vue?macro=true";
import { default as chairQ_45_ambEmS6sIQoP3uPqXThXRdt_3QVjj3CbyxDEzkG8Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/chair.vue?macro=true";
import { default as goodslQD1pzlDAdVgSHmiTvZZJW2WpBLPCInXeFBV_IKZSxgMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/goods.vue?macro=true";
import { default as indexKrb_YjbnentqMd1VDPS0XEMjjXhZHharhbWKulPKhV8Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/index.vue?macro=true";
import { default as metal1gI3cmIAZEQwi2b05EYdUVgXcXJpRNyfOswbxKBhpjkMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoauZvKQgMsXqBu8FaKRQmKgwmBBDjLFhFGsn798XT82UMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/piano.vue?macro=true";
import { default as pipesEmV0B_9ZI0h6fNGgei8xsgoxiAtM9bquOWBM60rfGsgMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/pipes.vue?macro=true";
import { default as tools0nxVfxR9kGEfgwomzY8w_FdAbX6CGO587dfg5sre61UMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxsPO_OR_2NnSwgrwYcjDEi4IXlCWk3o_45IOKJb3DGFymoMeta } from "/var/www/2025-06-26_17_44/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93q8Cp1wyCgKRWB_45GSYRuJYsSwxeFJQBfAtmbVt7737ywMeta } from "/var/www/2025-06-26_17_44/pages/personal/bonus/[tab].vue?macro=true";
import { default as printFNE5DyKMJkZ9xJ_5ko9pV2j1C7MHR15I7hPwWS2BKjoMeta } from "/var/www/2025-06-26_17_44/pages/personal/order/print.vue?macro=true";
import { default as dishesNR1H3MT1xunooCsKNWR_45Pv54vzwkLimyTnAijiI49C4Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/dishes.vue?macro=true";
import { default as enginelpwupt4_45H08HbnXfPyCDVtWoJTPgQIACmLgYFQPtBVsMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberiAD4wPP0zo1ZL7nGirzpaYikoJIiyRRKBSnWrbITaiYMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheels6quGtqYtMfgdIepuRIQ650AMg2e6U9y_qmRIi4Db2qsMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmvxaedgl7PRby3lCUVTZYufM9P7mFbAz0gksrdg2ND_UMeta } from "/var/www/2025-06-26_17_44/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingeKVXotDhVMUavytwpwZMyDNnh_e4X9Qu3rKahOzdmKsMeta } from "/var/www/2025-06-26_17_44/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalM3N8s7lu_RibfgAvzZfhgCbUFtXhpmoTvdY07Z3Sj6IMeta } from "/var/www/2025-06-26_17_44/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93zVEvfMJvQT6348KDPb6r0g4ZvqgIOlSAFzRjkhUBMWAMeta } from "/var/www/2025-06-26_17_44/pages/personal/order/[guid].vue?macro=true";
import { default as createnAvsIaLrTHKPKUdoN0uZHx__45zaPZqkZpEYT9BEaY3kkMeta } from "/var/www/2025-06-26_17_44/pages/personal/order/create.vue?macro=true";
import { default as barrelsIRCcFr7of00C3DPm7CaMSClRj3tNR_KeerNytD15oP4Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesBhI1RtRNqxvRCPmmS7JxGEdfzY_XDE9ETM7uR2T4_f4Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragilelQVbPonumg1GIf76SlozrSIxI6lQaBot_1UzV0wVvVMMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerC4ZSyxgryJHhY8qUy_8viTWhKqcWYcAibYRx_fUtPMkMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packagezxhUvX4R6LjvBSM2R7Wyn8XOFjlJ5y7GHSOlhKWcSGgMeta } from "/var/www/2025-06-26_17_44/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successLuNiWxapRd5xRacWe17_45uGn1gpMq00WmMZuzcB_45M5AEMeta } from "/var/www/2025-06-26_17_44/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packagemK5Zd2gnJqrtct0lnCufeXr8WTcjY_45W5CeoqsK1b3vgMeta } from "/var/www/2025-06-26_17_44/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesUS7nMtRHxiltUGg_AL4NTIcO4ktTvEfP0neSuhwqiAAMeta } from "/var/www/2025-06-26_17_44/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93Pr7pshQdXh_E9d_45GGJEYcgZ2Bb_l2KlA3yE25JHw5kMMeta } from "/var/www/2025-06-26_17_44/pages/order/administer/[guid].vue?macro=true";
import { default as furnitureXJN_tPLOCQNwGIDcVhWM7Mj5OSPP7Xl5m0thsukqkkoMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedFZqp9naAFtHsUgG8DlCi9vNz_Dm8d1dweMjODqmWWeMMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bike5vzq_45tbklDwXx1yM0k9ZciUkbeybwmpyAYcj7WVDPOkMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93LCQP2WLN86UEJj0K9koc0HduVtKxth7ujXoPC58Ta_wMeta } from "/var/www/2025-06-26_17_44/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93xSg20n74HYwGs3WIkF_45gHBgGdGFty7Vw_gLoMnnk49oMeta } from "/var/www/2025-06-26_17_44/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsYUn_45btp1FqpGk4CK6Kon70i5FXGVKswCTP44WDBo2c8Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapers3iKRmYFdiMg4bMNqZ7OW5fSoxtrCeD5x_SFGItdxXVIMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargo2oc3zwhIxEzJ3c3PkdQjZkWup63NkpFYr3uynbdHD3AMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobilekJYqDjB2EkMfMRzT1lTfTbw0xFeKazUNyR4IHG4NPfsMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as index2lf3HhKeWRYpEV16HAp9PHgCfnse3nyhyLS8DMr5RW0Meta } from "/var/www/2025-06-26_17_44/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45market8jxkLL6nzswj1_C8ftaE5BVKF439zfr7IiA1qBDel9IMeta } from "/var/www/2025-06-26_17_44/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesv5I57D42qUqA08a8r_BMvRnHp7SXyDVhxZ8efl_DK1cMeta } from "/var/www/2025-06-26_17_44/pages/personal/orders/templates.vue?macro=true";
import { default as indexuNqTp_9iYk_45D2D8_45_nQFVElqvB5MC7kXiXWKQhDCSL0Meta } from "/var/www/2025-06-26_17_44/pages/personal/contractors/index.vue?macro=true";
import { default as refrigerator1DHpbOXdY0FID2AA0HYY5JB2SgPa8RkBOFT36icps1wMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93LzI8N7ICtgAWl7IFbQg9ZoyOZjD1YvlhYEwGnbXABRQMeta } from "/var/www/2025-06-26_17_44/pages/personal/contractors/[guid].vue?macro=true";
import { default as index0EQaTxnEzLWErih9XJ0wnFM4q5Lgp7B8p0fL61csjuIMeta } from "/var/www/2025-06-26_17_44/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93RQStsAJAwmyFv5FTrI_mcGAnkH6SIGbbrYUPlYHQn_450Meta } from "/var/www/2025-06-26_17_44/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsGDiBzurPsgcxaIpDJVWBYugfcLS57kc4N3_45HvcvpxI0Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexVzl4qAgmYa_PRhBIO_3rE_JWIaGm_45l7m9cCtmMR2Vp8Meta } from "/var/www/2025-06-26_17_44/pages/personal/group-printing/index.vue?macro=true";
import { default as indexmGFB_45wB_45kZa6A0k2ZYvAfwoBxqOPADaurjhswRTTEsQMeta } from "/var/www/2025-06-26_17_44/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devicespZMES23vbkL_lTgMkmdM43Hxz7QaKXy1APdsWc3XEtQMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93q720pyKzCLLAY5iaLowcUec_45b65FOA7VygVNmbLXVF8Meta } from "/var/www/2025-06-26_17_44/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93h8DIHB24uJHQ_45OfEos9Y_458y46mLp0thKVNcVBK99JnwMeta } from "/var/www/2025-06-26_17_44/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93YgGZpzXqYaRxcFPgMQQUgw7_4597WVXMYJr6VnE9ZxAcoMeta } from "/var/www/2025-06-26_17_44/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipment2A52oZ_45VQiIFlx52w7hMqLTZeOO3lQA57cwM1zt_45ptUMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialszNBJs44XgdQK0xGR_45MQfvYpx_45PquYL3TLLAxabWbx_gMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentsU9G_45aH4szoHaBaqP2h0NnN8PtHRf4q4PBuWexVLo03oMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentj4eB6nHHZ7gHsluKF_450u90dbanX7jzac_45VpKCf2PZ5YMeta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationl8qFSt8w_45k9_Jqb8pUaLy49nekyoptIIzZ3RTX5MOm4Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93NF_e3zA7yZdPuvYeFwgiaS_5h6mbZAHsD_45ctW2H1q9wMeta } from "/var/www/2025-06-26_17_44/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationOoRpNulJPzVFJJS38oSzLBFvRy_45hXqT9PIhWYI5Eky4Meta } from "/var/www/2025-06-26_17_44/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-06-26_17_44/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-06-26_17_44/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-06-26_17_44/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-06-26_17_44/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93c4O_45q9VnwOxqk8tK9v_upFVcGDIW1kT12SjqEkRBl5EMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-06-26_17_44/pages/cookie.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-06-26_17_44/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-06-26_17_44/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-06-26_17_44/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-06-26_17_44/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkurs5Z_45jnlcr823pAZoCXK6cp0I8vENHBsg2IV9xlARTfg0Meta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-06-26_17_44/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-06-26_17_44/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-06-26_17_44/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contacts8_45HGs5MLZIOKjqGQtfhOLd5MF_WKNVtEC8q_45r7D93L0Meta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-06-26_17_44/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-06-26_17_44/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-06-26_17_44/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-06-26_17_44/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-06-26_17_44/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-06-26_17_44/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-06-26_17_44/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-06-26_17_44/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeOX76Eh6A3L3XbeWzr1uPmNvVBW_45eZrn1tiy3TyrmoPQMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_938GUSwTiVyYbjocVWw9z9thGD9RuWgwdJ34Zo_xn4bXUMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-06-26_17_44/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-06-26_17_44/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-06-26_17_44/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-06-26_17_44/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-06-26_17_44/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-06-26_17_44/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexigydudXffnhodtkIygNnsFeV8a2oX0Me1_a_QHYmANcMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-06-26_17_44/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-06-26_17_44/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorMRHWgJmimPeMLnKCwNhilflYCf9dt7kaPwAnqVE9jtcMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexSBU6i56mlyV87zxsbhX9tqPewbVQevD4oHWWlKRJUe8Meta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-06-26_17_44/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-06-26_17_44/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-06-26_17_44/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93bn9aXC4ak5wp1UyTfSsdJtpmJn7eEjtvNTCy33l6vIgMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-06-26_17_44/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-06-26_17_44/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-06-26_17_44/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-06-26_17_44/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-06-26_17_44/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-06-26_17_44/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-06-26_17_44/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-06-26_17_44/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-06-26_17_44/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-06-26_17_44/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-06-26_17_44/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-06-26_17_44/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayO6LhDDvKLhK4ldp3wxBR3aN4WU5PfRWIhhosFBNMTM4Meta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manageHpSpi_eSx8GWw7ShUhI2E4fqZ7KcKAIUY8eCyoqr7noMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-06-26_17_44/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-06-26_17_44/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsGOlGWpPJ7qmtbvIUyzwVJQT5irdJpwqxOVFvkoHl3OQMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-06-26_17_44/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexd272QiqXq3zeDxcXThjOEgnBySYLebvgASqbuWMZgKEMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-06-26_17_44/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-06-26_17_44/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-06-26_17_44/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-06-26_17_44/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-06-26_17_44/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-06-26_17_44/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-06-26_17_44/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importC2IKMgAgGvLQIxCfZwrujT2f3Xob_45FpDFTQIJsmFTqoMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutj9V_wzVrZ_zRvbh0IyGsmcLAoHWZzySqbwQ_jPJ6yuYMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-06-26_17_44/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-06-26_17_44/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024Re1C2fBIbZRqdoHDyK1FLGdSWt9JDK9fKL9tdDHvM5gMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonV8YhVbEzp8ufmjtUpwgrlwxNaHxk0W4HFcAevjOFohwMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-06-26_17_44/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountsYdmlLc_3xeatDjvTGSJjZY4kN4vdkiUZvLMELpKMUgMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-06-26_17_44/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-06-26_17_44/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-06-26_17_44/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-06-26_17_44/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorltYqSPQEpy7pOyDDA_45lGHQPuJvQk_45QwPK5W4Fp6ij5gMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-06-26_17_44/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-06-26_17_44/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-06-26_17_44/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountLye18ptGRYL4mzHsxB4Oq_45YnM7UIY277Or_cPU6StS0Meta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-06-26_17_44/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-06-26_17_44/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917kVPXIyMhp0xOBlzeS9YwGfVLQQsWiyjdTY37kAXucPMMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-06-26_17_44/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indextL8MsYhcrwl9CuWInQN8V1OgWyoMeEn7GJ71Jd5g3yYMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-06-26_17_44/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesoyEfvErExsgYndiP_45nTH2Mu1_ctf5pr_s6Dix6Vz5YwMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-06-26_17_44/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93q8Cp1wyCgKRWB_45GSYRuJYsSwxeFJQBfAtmbVt7737ywMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printFNE5DyKMJkZ9xJ_5ko9pV2j1C7MHR15I7hPwWS2BKjoMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-06-26_17_44/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-06-26_17_44/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-06-26_17_44/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93zVEvfMJvQT6348KDPb6r0g4ZvqgIOlSAFzRjkhUBMWAMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createnAvsIaLrTHKPKUdoN0uZHx__45zaPZqkZpEYT9BEaY3kkMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-06-26_17_44/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-06-26_17_44/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-06-26_17_44/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesUS7nMtRHxiltUGg_AL4NTIcO4ktTvEfP0neSuhwqiAAMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-06-26_17_44/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-06-26_17_44/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93xSg20n74HYwGs3WIkF_45gHBgGdGFty7Vw_gLoMnnk49oMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: index2lf3HhKeWRYpEV16HAp9PHgCfnse3nyhyLS8DMr5RW0Meta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45market8jxkLL6nzswj1_C8ftaE5BVKF439zfr7IiA1qBDel9IMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesv5I57D42qUqA08a8r_BMvRnHp7SXyDVhxZ8efl_DK1cMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexuNqTp_9iYk_45D2D8_45_nQFVElqvB5MC7kXiXWKQhDCSL0Meta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93LzI8N7ICtgAWl7IFbQg9ZoyOZjD1YvlhYEwGnbXABRQMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: index0EQaTxnEzLWErih9XJ0wnFM4q5Lgp7B8p0fL61csjuIMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93RQStsAJAwmyFv5FTrI_mcGAnkH6SIGbbrYUPlYHQn_450Meta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexVzl4qAgmYa_PRhBIO_3rE_JWIaGm_45l7m9cCtmMR2Vp8Meta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexmGFB_45wB_45kZa6A0k2ZYvAfwoBxqOPADaurjhswRTTEsQMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93q720pyKzCLLAY5iaLowcUec_45b65FOA7VygVNmbLXVF8Meta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93h8DIHB24uJHQ_45OfEos9Y_458y46mLp0thKVNcVBK99JnwMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93YgGZpzXqYaRxcFPgMQQUgw7_4597WVXMYJr6VnE9ZxAcoMeta || {},
    component: () => import("/var/www/2025-06-26_17_44/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-06-26_17_44/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-06-26_17_44/pages/shippingtypes/personalitemstransportation.vue")
  }
]